import { Selector } from '@ngxs/store';
import { AuthToken } from '../../../domain/auth/model/auth-token';
import { UserType } from '../../../domain/auth/model/UserType';
import { AuthState, AuthStateModel } from './auth.state';

export class AuthSelectors {
  @Selector([AuthState])
  static getCurrentLogged(state: AuthStateModel) {
    return state.account;
  }

  @Selector([AuthState])
  static isProcessing(state: AuthStateModel) {
    return state.isProcessing;
  }

  @Selector([AuthState])
  static username(state: AuthStateModel) {
    return state.username;
  }

  @Selector([AuthState])
  static token(state: AuthStateModel): AuthToken | null {
    return state.token;
  }

  @Selector([AuthState])
  static isAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
  }

  @Selector([AuthState])
  static userType(state: AuthStateModel) {
    return state.account?.userType;
  }

  @Selector([AuthState])
  static isAdmin(state: AuthStateModel) {
    return state.account?.userType === UserType.ADMIN;
  }

  @Selector([AuthState])
  static isLoggedFromSocial(state: AuthStateModel) {
    return state.account?.isLoggedFromSocial;
  }
}
